// Main JavaScript file for PIANO theme Wishlist functionality
function toggleWishlist(productId) {

// Get current wishlist from localStorage
  let wishlist = JSON.parse(localStorage.getItem("piano_wishlist") || "[]");

// Check if product is already in wishlist
  const index = wishlist.indexOf(productId);

  if (index === -1) { // Add to wishlist
    wishlist.push(productId);
    console.log(`Added product ${productId} to wishlist`);
  } else { // Remove from wishlist
    wishlist.splice(index, 1);
    console.log(`Removed product ${productId} from wishlist`);
  }

// Save updated wishlist
  localStorage.setItem("piano_wishlist", JSON.stringify(wishlist));

// Update wishlist UI elements if needed
  updateWishlistUI();
}

// Update wishlist UI elements
function updateWishlistUI() {

// Get current wishlist from localStorage
  const wishlist = JSON.parse(localStorage.getItem("piano_wishlist") || "[]");

// Update wishlist count in header if it exists
  const wishlistCountElement = document.querySelector(".wishlist-count");
  if (wishlistCountElement) {
    wishlistCountElement.textContent = wishlist.length;
  }

// Update wishlist icons on product cards
  document.querySelectorAll("[data-product-id]").forEach((element) => {
    const productId = parseInt(element.dataset.productId);
    const isInWishlist = wishlist.includes(productId);

// Find the wishlist icon within this product card
    const wishlistIcon = element.querySelector(".wishlist-icon");
    if (wishlistIcon) {
      if (isInWishlist) {
        wishlistIcon.classList.add("active");
      } else {
        wishlistIcon.classList.remove("active");
      }
    }
  });
}

// Product Image Slideshow functionality
function initProductSlideshows() {
  const slideshows = document.querySelectorAll("[data-product-slideshow]");

    slideshows.forEach((slideshow) => {
      const slides = slideshow.querySelectorAll(".product-slide");
      const indicators = slideshow.querySelectorAll("[data-slide-indicator]");

      if (slides.length <= 1) return;

      let currentIndex = 0;
      let slideshowInterval = null;
      let isAnimating = false;

      // Function to show a specific slide
      function showSlide(index) {
        if (isAnimating || index === currentIndex) return;

        isAnimating = true;

        // Hide current slide
        slides[currentIndex].classList.remove("active");

        // Show new slide
        slides[index].classList.add("active");

        // Update indicators
        indicators.forEach((indicator, i) => {
          if (i === index) {
            indicator.classList.add("bg-white");
            indicator.classList.remove("bg-white/50");
          } else {
            indicator.classList.remove("bg-white");
            indicator.classList.add("bg-white/50");
          }
        });

        // Update current index
        currentIndex = index;

        // Reset animation flag after transition completes
        setTimeout(() => {
          isAnimating = false;
        }, 600); // Match this to the CSS transition duration
      }

      // Start automatic slideshow
      function startSlideshow() {
        stopSlideshow();
        slideshowInterval = setInterval(() => {
          if (!isAnimating) {
            let nextIndex = currentIndex + 1;
            if (nextIndex >= slides.length) {
              nextIndex = 0;
            }
            showSlide(nextIndex);
          }
        }, 5000); // Change slide every 5 seconds
      }

      // Stop automatic slideshow
      function stopSlideshow() {
        if (slideshowInterval) {
          clearInterval(slideshowInterval);
          slideshowInterval = null;
        }
      }

      // Initialize slideshow
      startSlideshow();

      // Pause slideshow on hover
      slideshow.addEventListener("mouseenter", stopSlideshow);
      slideshow.addEventListener("mouseleave", startSlideshow);

      // Add click event to indicators
      indicators.forEach((indicator, index) => {
        indicator.addEventListener("click", (e) => {
          e.preventDefault();
          if (!isAnimating) {
            showSlide(index);
            stopSlideshow();
            startSlideshow();
          }
        });
      });
    });
  }

// Password visibility toggle using event delegation for modal support
document.addEventListener('click', function(event) {
  // Check if clicked element is a password toggle button
  if (event.target.closest('.password-toggle-btn')) {
    event.preventDefault();
    
    const toggleBtn = event.target.closest('.password-toggle-btn');
    const wrapper = toggleBtn.closest('.password-field-wrapper');
    
    if (wrapper) {
      const checkbox = wrapper.querySelector('.password-visibility-toggle');
      const passwordInput = wrapper.querySelector('.password-input');
      const eyeOffIcon = wrapper.querySelector('.eye-off-icon');
      const eyeOnIcon = wrapper.querySelector('.eye-on-icon');
      
      if (checkbox && passwordInput && eyeOffIcon && eyeOnIcon) {
        // Toggle checkbox state
        checkbox.checked = !checkbox.checked;
        
        // Update password visibility based on checkbox state
        if (checkbox.checked) {
          // Password hidden
          passwordInput.style.webkitTextSecurity = 'disc';
          passwordInput.style.textSecurity = 'disc';
          eyeOffIcon.style.display = 'block';
          eyeOnIcon.style.display = 'none';
        } else {
          // Password visible
          passwordInput.style.webkitTextSecurity = 'none';
          passwordInput.style.textSecurity = 'none';
          eyeOffIcon.style.display = 'none';
          eyeOnIcon.style.display = 'block';
        }
      }
    }
    
    return false;
  }
});

// Initialize wishlist UI and product slideshows when page loads
document.addEventListener("DOMContentLoaded", function() {
  updateWishlistUI();
  initProductSlideshows();
});